

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$PADFactory', function () {

    /**
     *
     * get PAD or IACH plan id based on selected plan id and PAD toggle status
     * if selected plan is IACH and toggle is on -> use associated PAD plan id
     * if selected plan is IACH and toggle is off -> use it's ID
     * if selected plan is PAD and toggle is on -> use it's ID
     * if selected plan is PAD and toggle is off -> use associated IACH plan id
     */
    var getPadOrIachBankPlanId = function getPadOrIachBankPlanId(_ref) {
        var selectedMethodPlanId = _ref.selectedMethodPlanId,
            fundingOptions = _ref.fundingOptions,
            multiFiCheckboxStates = _ref.multiFiCheckboxStates;

        var plan = fundingOptions.getPlanByPlanId(selectedMethodPlanId);
        var padOrIachPlanId = void 0;

        if (fundingOptions.isPAD(plan) || fundingOptions.isIACH(plan)) {
            if (multiFiCheckboxStates[plan.primaryFs.id]) {
                padOrIachPlanId = fundingOptions.getPadOrIachPlanIdBySelectedPlan({ plan: plan, isPadToggleSelected: true });
            } else {
                padOrIachPlanId = fundingOptions.getPadOrIachPlanIdBySelectedPlan({ plan: plan, isPadToggleSelected: false });
            }
        }
        return padOrIachPlanId;
    };

    // check if PAD feature is applicable
    var isPadToggleFeatureApplicable = function isPadToggleFeatureApplicable(padToggleFeature, isPadToggleEnabled) {
        return padToggleFeature.applicable && isPadToggleEnabled;
    };

    return {
        getPadOrIachBankPlanId: getPadOrIachBankPlanId,
        isPadToggleFeatureApplicable: isPadToggleFeatureApplicable
    };
});


//////////////////
// WEBPACK FOOTER
// ./pages/xo-review/factory.js
// module id = ./pages/xo-review/factory.js
// module chunks = 0